/**
 * landing-products-adapter — LandingProductDto → 页面行
 *
 * 契约 DTO 已是页面消费形态（snake_case）。本适配只把关联 app_ids 解析成展示名；
 * 解析不到的 id 落空，不编造产品名。
 */

import type { LandingProductDto } from '@novel-admin/shared';

export type LandingProductRow = LandingProductDto & {
  app_names: string[];
  /** listApps 成功才为 true；失败时不得把有效关联标成「未知」 */
  app_names_ready: boolean;
};

export function adaptLandingProduct(
  dto: LandingProductDto,
  appNameById: Record<string, string>,
  namesReady = true,
): LandingProductRow {
  return {
    ...dto,
    app_names: dto.app_ids.map((id) => appNameById[id] ?? ''),
    app_names_ready: namesReady,
  };
}

/** 列表展示：能解析的用 App 名，解析不到的标「未知」+ id 前缀，不丢脏关联 */
export function formatLandingAppLabels(
  row: Pick<LandingProductRow, 'app_ids' | 'app_names' | 'app_names_ready'>,
): string {
  if (!row.app_names_ready) {
    return row.app_ids.length > 0 ? `${row.app_ids.length} 个` : '';
  }
  return row.app_ids
    .map((id, i) => {
      const name = row.app_names[i]?.trim();
      return name || `未知 ${id.slice(0, 8)}`;
    })
    .join('、');
}
